<template>
  <div class="wrapper-layout">
    <div>
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LayoutWebsite",
});
</script>

<style scoped lang="scss">
@import "src/ux/layout/styles/layoutStyle";
</style>
